import React, { useState, useEffect } from 'react';

export const Progressbar = () => {
  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (value === 100) {
        clearInterval(interval);

        setTimeout(() => {
          setValue(0);
        }, 3000);
      } else {
        setValue(value + 1);
      }
    }, 100);

    return () => {
      clearInterval(interval);
    };
  }, [value]);

  return (
    <>
      <h2>Progressbar Demo</h2>
      <div
        className="progress mb-5"
        role="progressbar"
        aria-label="Animated striped example"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="progress-bar progress-bar-striped progress-bar-animated"
          style={{ width: `${value}%` }}
        >
          {value}%
        </div>
      </div>

      <h2>Colored Progressbar</h2>
      <div className="progress mb-2">
        <div
          className="progress-bar bg-success"
          role="progressbar"
          style={{ width: '15%' }}
          aria-valuenow={15}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          15%
        </div>
      </div>
      <div className="progress mb-2">
        <div
          className="progress-bar bg-black"
          role="progressbar"
          style={{ width: '25%' }}
          aria-valuenow={25}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          25%
        </div>
      </div>
      <div className="progress mb-2">
        <div
          className="progress-bar bg-danger"
          role="progressbar"
          style={{ width: '50%' }}
          aria-valuenow={50}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          50%
        </div>
      </div>
      <div className="progress mb-2">
        <div
          className="progress-bar bg-success"
          role="progressbar"
          style={{ width: '75%' }}
          aria-valuenow={75}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          75%
        </div>
      </div>
      <div className="progress mb-2">
        <div
          className="progress-bar bg-warning text-black"
          role="progressbar"
          style={{ width: '100%' }}
          aria-valuenow={100}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          100%
        </div>
      </div>
    </>
  );
};
